import { gql } from '@/features/graphql/generated'

export const CartQuery = gql(/* GraphQL */ `
    query Cart($cartKey: ID!) {
        cart(cartKey: $cartKey) {
            ...Cart
        }
    }
`)
